import Service from "./Service";

class PostalCodeApiService extends Service {
  constructor() {
    super("api");
  }

  async getCity(postalCode) {
    let result = await this.get(`/Claims/GetCity?postalCode=${postalCode}`, (status, data) => {
      return data;
    });
    return result;
  }
}

export default new PostalCodeApiService();
